import type { NamedSolution, TimeSeries } from '../../types';
import type { TimeSeriesChartData } from './timeSeries';

/** Reference production with and without soiling, and the production of each solution. */
export const productionChartData = (reference: TimeSeries | undefined, solutions: NamedSolution[]): TimeSeriesChartData => {
  const data: TimeSeriesChartData = {
    times: reference?.times as string[],
    values: {
      production: reference?.values?.production,
      no_soiling_production: reference?.values?.no_soiling_production,
    },
    // Shared with the reference on purpose: the solution units are added to the same object.
    units: reference?.units as Record<string, string>,
    title: 'Production',
    xTitle: 'Production (MWh/day)',
  };
  solutions.forEach((item) => {
    data.values[item.name + '_production'] = item?.data?.daily?.values?.production;
    if (data.units) data.units[item.name + '_production'] = item?.data?.daily?.units?.production as string;
  });
  return data;
};

/** Reference soiling ratio and the soiling ratio of each solution; a single solution also shows its cleanings. */
export const soilingRatioChartData = (
  rainDates: string[] | undefined,
  reference: TimeSeries,
  solutions: NamedSolution[],
): TimeSeriesChartData => {
  const data: TimeSeriesChartData = {
    times: reference?.times,
    values: { soiling_ratio: [...(reference?.values?.soiling_ratio as (number | null)[])] },
    units: reference?.units,
    title: 'Soiling Ratio',
    xTitle: 'Soiling Ratio',
  };

  solutions.forEach((item) => {
    // A cleaning schedule may wrap to the next year: the last value is repeated up to the reference length.
    const extended = [...(item?.data?.daily?.values?.soiling_ratio || [])];
    while (extended.length < reference?.times.length) {
      extended.push(extended[extended.length - 1] || 1.0);
    }
    data.values[item.name + '_soiling_ratio'] = extended;
    if (data.units) data.units[item.name + '_soiling_ratio'] = item?.data?.daily?.units?.soiling_ratio as string;

    if (solutions.length === 1) {
      data.values.cleaning = item?.cleaning_graph;
      data.cleaning_dates = item?.schedule;
    }
  });

  data.rain_dates = rainDates;
  return data;
};
